var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFalling24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgFalling24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    fill: "#e3e3e3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m540-60-80-16 32-172-144-108-52-228-88 76 32 152-80 16-40-196 178-159q23-20 54.5-16.5T413-696q32 14 66.5 20t69.5 1q35-5 64.5-23t56.5-40l50 62q-30 23-62 43t-69 31q-33 9-66.5 9.5T456-600l28 124 148-28 208 148-48 64-172-120-144 28 108 80-44 244ZM263.5-763.5Q240-787 240-820t23.5-56.5Q287-900 320-900t56.5 23.5Q400-853 400-820t-23.5 56.5Q353-740 320-740t-56.5-23.5Z"
  })));
};
export default SvgFalling24DpE3E3E3Fill0Wght400Grad0Opsz24;